export default __webpack_public_path__ + "static/media/gripe-support1.c2bc440b.png";